export default __webpack_public_path__ + "static/media/brain_icon.12da5690.svg";